import React from "react";
import "../src/App.css";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

import ComingSoon from "./Pages/ComingSoon";
import CameraKit from "./Pages/CameraKitPage";
import LoadingPage from "./Pages/LoadingPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/camera-kit" element={<CameraKit />} />
        <Route path="/id/:id" element={<LoadingPage />} />
        <Route path="*" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
}

export default App;
